import BaseService from '@/services/BaseService';

class CountryListService extends BaseService {
    getCountries = (filters) => this.post('/getagencycountries', filters || { });
}

export default new CountryListService();
